import axios from "axios";
import base64 from "base-64";
import ENV from "../env";

   const verifyOtpApi = async (body, history, type, toast, setDisButton) => {
    Promise.all([
        localStorage.getItem('userId'),
        localStorage.getItem('sToken')
    ]).then(async (res) => {
        let userId = res[0];
        let sToken = res[1];
        let header = base64.encode(`${userId}:${sToken}`);
        let security = `Basic ${header}`;

        const options = {
            headers: {
                'Accept': 'application/json',
                'Security': security,
                'Content-Type': 'application/json',
            }
        };

        const response = await axios.post(`${ENV.LOCUSB_API}/ValidateCode`, body, options)


        if (response?.data?.success === "true") {
            if (type) {
                localStorage.removeItem('forget');
                history.push('/reset-pwd')
            } else {
                history.push('/qr-code')
                toast.success("Login Succesfully!")
            }
        }
        else {
            if (response.data.errorMsg === "SecureID_Expired") {
                toast.warning("Token Expired!")
            }
            else {
                if (response.data.errorMsg === "Invalid_SecureID") {
                    toast.warning("Incorrect Code!")

                } else {
                    toast.error("Login failed!")
                }
            }
            setDisButton(false)
        }
    }).catch((err) => {
        console.log("err", err)
    })

}

export default verifyOtpApi;
